import React, { FC, useCallback } from 'react';
import { BaseFieldProps, WrappedFieldProps } from 'redux-form';
import { FormItemProps } from 'antd/lib/form';
import { CheckboxProps } from 'antd/lib/checkbox';
import { Form, Space, Checkbox } from 'antd';
import { Stack } from 'components/stack/stack';
import { Text } from 'components/text/Text';
import { SelectOption } from '../select-option/select-option';
import { isOptionValueEnabled, toogleOptionValue } from './form-input-check-box-select.logic';
import styled from 'styled-components';

interface FormInputCheckBoxSelectOwnProps extends FormItemProps {
  name: string;
  placeholder?: string;
  options: SelectOption[];
}

export type FormInputCheckBoxSelectProps = FormInputCheckBoxSelectOwnProps &
  BaseFieldProps<FormInputCheckBoxSelectOwnProps>;

export const FormInputCheckBoxSelect: FC<WrappedFieldProps & FormInputCheckBoxSelectProps> = ({
  input,
  meta,
  options,
}) => {
  const errorMessage = !!meta && meta.error;
  const showError = !!meta && meta.touched && !!meta.error;
  const { onChange } = input;

  const isChecked = useCallback(
    (option: SelectOption) => isOptionValueEnabled(input.value, option.value),
    [input.value]
  );

  const handleOnChange: (option: SelectOption) => CheckboxProps['onChange'] = useCallback(
    (option) => (e) => {
      const selectedOptions = input.value as any[];
      const newValue = toogleOptionValue(selectedOptions, option.value) || null;
      onChange(newValue);
    },
    [input.value, onChange]
  );

  return (
    <Form.Item
      validateStatus={showError ? 'error' : undefined}
      help={showError ? errorMessage : undefined}
    >
      <Stack flow="row">
        {options.map((option) => (
          <Container key={option.value} direction={'horizontal'}>
            <CheckboxOption checked={isChecked(option)} onChange={handleOnChange(option)}>
              <Text size={14}>{option.label}</Text>
            </CheckboxOption>
          </Container>
        ))}
      </Stack>
    </Form.Item>
  );
};

const Container = styled(Space)`
  margin-bottom: 10px;
`;

const CheckboxOption = styled(Checkbox)`
  margin-left: 10px;

  .ant-checkbox-inner {
    border-radius: 2px;
  }
`;
